type NullableString = String | null;

const CHARACTER_LIMIT = 400;

const isAbove400CharactersLimit = (...nullableStrings: NullableString[]) =>
  nullableStrings.reduce((sum, nullableString) => sum + (nullableString?.length || 0), 0) > CHARACTER_LIMIT;

export default isAbove400CharactersLimit;
